export const eventData = [
  {
    imgSrc:"./images/sub/event/event01.jpg",
    eventTit:"365일 사랑받는 스니커즈 시즌오프~50%",
  },
  {
    imgSrc:"./images/sub/event/event02.jpg",
    eventTit:"NEW 올 겨울 내 발을 따뜻하게",
  },
  {
    imgSrc:"./images/sub/event/event03.jpg",
    eventTit:"컨버스 체험단 모집 EVENT",
  },
  {
    imgSrc:"./images/sub/event/event04.jpg",
    eventTit:"11월 특가! 최대 70% 할인",
  },
  {
    imgSrc:"./images/sub/event/event05.jpg",
    eventTit:"NEW 빈티지 캔버스 썬플라워",
  },
  {
    imgSrc:"./images/sub/event/event06.jpg",
    eventTit:"남성 데일리 스니커즈 기간한정 15% 쿠폰",
  },
];